import { CaixaProps } from "../../components/Estrutura/Caixa";

export const instrumentos: CaixaProps[] = [
  {
    nome: "Guitarra Fender Squier Stratocaster",
    descricao:
      "Guitarra 1",
    img: "/assets/Estudio/IMG_8720.jpg"
    // img: "/assets/Estudio/ney.jpeg",
  },
  {
    nome: "Guitarra Tagima Vulcan",
    descricao:
      "Guitarra 2", 
    img: "/assets/Estudio/IMG_4387.jpg",
  },
  {
    nome: "Guitarra EVH Frankenstrat",
    descricao:
      "Guitarra 3",
    img: "/assets/Estudio/IMG_8941.jpg",
  },
  // {
  //   nome: "Guitarra SG",
  //   descricao:
  //     'Guitarra 4',
  //   img: "/assets/Estudio/IMG_8687.jpg",
  // },
  // {
  //   nome: "Guitarra Fender Squier Stratocaster",
  //   descricao:
  //     'Guitarra 5',
  //   img: "/assets/Estudio/IMG_8684.jpg",
  // },
  {
    nome: "Baixo Stringberg CLB25A 5 Cordas",
    descricao:
      "Baixo 1",
    img: "/assets/Estudio/IMG_8727.jpg",
  },
  {
    nome: "Teclado Yamaha PSS-F30",
    descricao:
      'Teclado 1',
    img: "",
  },

  {
    nome: "Violão 7 Cordas Rozini Pro",
    descricao:
      "Violão 1",
    img: "",
  },
  {
    nome: "Violão de Aço Aria FET-DLX",
    descricao:
      "Violão 2",
    img: "/assets/Estudio/IMG_4388.jpg",
  },
  {
    nome: "Bateria 1",
    descricao:
      "Bateria 1",
    img: "/assets/Estudio/IMG_4334.jpg",
  },
  {
    nome: "Bateria 2",
    descricao:
      "Bateria 2",
    img: "/assets/Estudio/IMG_8934.jpg",
  },
  {
    nome: "Pratos de Bateria",
    descricao:
      "Pratos de Bateria",
    img: "",
  },
  {
    nome: "Viola Caipira Del Vecchio",
    descricao:
      "Viola 1",
    img: "/assets/Estudio/IMG_8946.jpg",
  },
  {
    nome: "Cavaquinho Giannini",  
    descricao:
      "Cavaquinho",
    img: "",
  } 
];
